import { emailRegex } from "lib/utils/FormValidations";

export function formatDate(timeString) {
  return new Date(timeString).toLocaleDateString(Intl.Locale, {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(dateSring) {
  return new Date(dateSring).toLocaleString(Intl.Locale, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
}

export function formatTime(dateString) {
  return new Date(dateString).toLocaleTimeString(Intl.Locale, {
    hour: "numeric",
    minute: "numeric",
  });
}

export function isEmail(string) {
  if (!string) {
    return false;
  }
  return emailRegex.test(string);
}

export function isPhoneNumber(string) {
  if (!string) {
    return false;
  }
  const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/; // Matches formats like +1 (123) 456-7890, 123-456-7890, etc.
  return phoneRegex.test(string);
}

export function isHttpsUrl(string) {
  return /^https:\/\/[^\s/$.?#].[^\s]*$/i.test(string);
}

export function isValidPassword(password) {
  if (!password) {
    return false;
  }
  // Password must be at least 12 characters, contain at least one uppercase letter,
  // one lowercase letter, one special character, and have no whitespace
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?=\S+$).{12,}$/;
  return passwordRegex.test(password);
}

export function downloadURI(uri, name) {
  var link = document.createElement("a");
  link.download = name;
  link.href = uri;
  link.click();
  link.remove();
}

export function toTitleCase(str) {
  return (str || "").replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
  );
}

export function setEntityCssVariables(entity) {
  if (entity) {
    const {
      primarycolor,
      secondarycolor,
      primarytextcolor,
      secondarytextcolor,
      highlight_color,
    } = entity;

    const primaryColor = primarycolor || "0,0,0";
    const secondaryColor = secondarycolor || "22,22,22";
    const cssVariables = {
      "--primary-color": `rgb(${primaryColor})`,
      "--primary-color-seethrough": `rgba(${primaryColor}, 0.8)`,
      "--secondary-color": `rgb(${secondaryColor})`,
      "--primary-text-color": `rgb(${primarytextcolor || primaryColor})`,
      "--secondary-text-color": `rgb(${secondarytextcolor || secondaryColor})`,
      "--highlight-color": `rgb(${highlight_color || primaryColor})`,
    };

    Object.keys(cssVariables).forEach((key) => {
      document.documentElement.style.setProperty(key, cssVariables[key]);
    });
  }
}

export function parseErrorList(error) {
  if (error.response?.data?.errors) {
    // response.data.errors is a key value pair of property name and array of errors
    // e.g. { name: ["Name is required"], goal: ["Goal must be a positive number"] }
    // we need to convert it to a string
    let errors = "";
    for (const key in error.response.data.errors) {
      if (errors) {
        errors += ", ";
      }

      errors += `${key} ${error.response.data.errors[key].join(", ")}`;
    }

    if (errors) {
      return errors;
    }
  }

  return "Something went wrong creating your campaign.";
}

export function toEmbeddableLink(url) {
  if (!url) {
    return "";
  }

  // Check if the URL is a YouTube link
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
  if (youtubeRegex.test(url)) {
    // Convert YouTube URL to embeddable format
    const videoId = url.includes("shorts")
      ? url.split("shorts/")[1]?.split("&")[0]
      : url.split("v=")[1]?.split("&")[0];
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }
  }
  // Check if the URL is a Vimeo link
  const vimeoRegex = /^(https?:\/\/)?(www\.)?vimeo\.com\/(\d+)$/;
  if (vimeoRegex.test(url)) {
    // Convert Vimeo URL to embeddable format
    const videoId = url.split("/").pop();
    return `https://player.vimeo.com/video/${videoId}`;
  }
  // If it's neither YouTube nor Vimeo, return the original URL
  return url;
}
